import { render, staticRenderFns } from "./CommunityMembers.vue?vue&type=template&id=b4f3cab4&"
import script from "./CommunityMembers.vue?vue&type=script&lang=js&"
export * from "./CommunityMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports